module.exports = __webpack_public_path__ + "img/no-image.85d18780.png";